module.exports = __webpack_public_path__ + "static/mobby-scheme-c518cb40646c2f51b35bb241d93bb605.svg";